import { render } from "./AtomicOrdersNotice.vue?vue&type=template&id=46159312&scoped=true"
import script from "./AtomicOrdersNotice.vue?vue&type=script&lang=js"
export * from "./AtomicOrdersNotice.vue?vue&type=script&lang=js"

import "./AtomicOrdersNotice.vue?vue&type=style&index=0&id=46159312&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46159312"]])

export default __exports__